import { RpcSmeExtensionRequestResult } from './rpc-sme-extension-model';

/**
 * Rpc extension response server side handler interface.
 */
export interface RpcSmeExtensionResponseHandler {
    handler(data: RpcSmeExtensionRequestResult): Promise<void>;
}
